module.exports = __webpack_public_path__ + "static/media/close-modal-button.3784eb7e.svg";